module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsSAAALEgHS3X78AAABT0lEQVRIx92WvXHCQBCFPzSXo4jsZnAF0IEpAAWuwFCBFRMRKVYHQAeeOQrAHeAKrLEyoqMCOVnGDD6dTpJx4Bfqdt6bfav9GVRVRR3ipBwDKTADJo6Qd+AA5Nbooo5n4BIR8jXwTDh2wNol9kMkTsoFkAND2uMMpNboba2ICGzoj+W1UHQHAYCN8H1nIjU4drTIZ93UGl0o+bB2CVijG5nipKx7GgrvYjCcf46BD1eUNdpH0vgueIikDzpjn43YZyNfSKqk0bxw2XbJYL46NYnMVE0nh/oegokKifJlEoIgkZ6Z8H8yiWRc3xNvSvbBpI1VLXFUMtZffDbtsxHz1amrSK6s0UWclLumBdXQcLWLzBpd/MkUjsT3ou8Mc82syyqOrgq8BZa/JODejDdC5x4WPd3u+Mjxy26BqVwfrYosNXgNOokcd9cUeOx6d30B30iTWqiVNc8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Copy text.png
// module id = 134
// module chunks = 0 1